var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.416992C10.4 0.416992 9.66671 1.0475 9.66671 1.67801H4.33337C4.33337 1.0475 3.60004 0.416992 3.00004 0.416992H0.333374V6.09157C0.333374 6.72208 1.00004 7.35259 1.66671 7.35259H3.13337C3.40004 8.6136 4.26671 9.68547 6.33337 9.87462V11.1861C4.33337 11.4761 4.33337 13.0272 4.33337 13.0272H9.66671C9.66671 13.0272 9.66671 11.4761 7.66671 11.1861V9.87462C9.73337 9.68547 10.6 8.6136 10.8667 7.35259H12.3334C13 7.35259 13.6667 6.72208 13.6667 6.09157V0.416992H11ZM3.00004 6.09157H1.66671V1.67801H3.00004V6.09157ZM9.66671 6.40682C9.66671 7.6237 9.28004 8.6136 7.00004 8.6136C4.72671 8.6136 4.33337 7.6237 4.33337 6.40682V2.93903H9.66671V6.40682ZM12.3334 6.09157H11V1.67801H12.3334V6.09157Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwards);
export default __webpack_public_path__ + "static/media/awards.615d71c6.svg";
export { ForwardRef as ReactComponent };